import { normalize, schema } from 'normalizr';
import { EventTransitionViewModel } from 'stageclip-common';

import { ById } from '../../store/normalizedState';

import * as EntityNormalizers from './entityNormalizers';

const { Entity } = schema;

export interface NormalizedEventTransitions {
  eventTransitions: ById<EventTransitionViewModel>;
}

// the idAttribute is not unique but it does not matter as the eventTransitions are not stored in state
export const eventTransitionSchema = new Entity(
  'eventTransitions',
  {},
  {
    idAttribute: value => value.state,
  },
);

export function normalizeEventTransition(
  data: EventTransitionViewModel,
): EntityNormalizers.NormalizedSingleEntity<NormalizedEventTransitions> {
  return normalize(data, eventTransitionSchema);
}
